import "keen-slider/keen-slider.min.css";
import KeenSlider from "keen-slider";

export function setupSlider() {
    const element = document.getElementById("header-slider");

    if (!element) {
        return;
    }

    const slider = new KeenSlider(element, {
        loop: true,
        centered: true,
        duration: 5000,
        slidesPerView: 1,
        created: () => {
            element.classList.remove("opacity-0");
        },
    });

    const left = document.getElementById("header-slider-left");
    left.addEventListener("click", () => slider.prev());
    const right = document.getElementById("header-slider-right");
    right.addEventListener("click", () => slider.next());
}
